import { render } from "./Hotspot19.vue?vue&type=template&id=ee9f71c4&scoped=true&ts=true"
import script from "./Hotspot19.vue?vue&type=script&lang=ts"
export * from "./Hotspot19.vue?vue&type=script&lang=ts"

import "./Hotspot19.vue?vue&type=style&index=0&id=ee9f71c4&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9f71c4"]])

export default __exports__